import { dynamicLoadUpgradeQueries } from '../utils';
export const isSwitchFlowQueryFn = async _ref => {
  let {
    httpClient
  } = _ref;
  const {
    getCurrentProduct
  } = await dynamicLoadUpgradeQueries(httpClient);
  const {
    currentProduct
  } = await getCurrentProduct({});
  return {
    isSwitchFlow: Boolean(currentProduct)
  };
};
//# sourceMappingURL=isSwitchFlow.query.js.map